import { atom } from 'jotai';
import { WEIGHT_FACTOR } from '@/constants';

export const weightFactorAtom = atom<number>(WEIGHT_FACTOR);
